// DatahubIntegrationPage.jsx
import React, { useMemo, useState } from 'react';
import {
  Alert,
  Box,
  Button,
  Card,
  CardActionArea,
  CardContent,
  CardHeader,
  Chip,
  CircularProgress,
  Container,
  DialogActions,
  Divider,
  Grid,
  List,
  ListItemText,
  Popper,
  Stack,
  TextField,
  Typography,
} from '@mui/material';
import dayjs from 'dayjs';
import { useDispatch, useSelector } from 'react-redux';
import { getSelectedAccount } from '../../../redux/selectedAccountSlice';
import {
  useGetDatahubAccountByIdQuery,
  usePostDatahubIntegrationAccountMutation,
  usePostDatahubIntegrationAccountRetryMutation,
} from '../../../api/datahub-integration/datahubIntegrationApiSlice';
import { useNavigate } from 'react-router-dom';
import { cvrApiSlice } from '../../../api/datahub-integration/cvrApiSlice';
import DatahubIntegrationAccountCard from './DatahubIntegrationAccountCard';
import SearchIcon from '@mui/icons-material/Search';
import { showSnackbar } from '../../../redux/snackbarSlice';
import { useTranslation } from 'react-i18next';
import MuiComponentSamples from './MuiComponentSamples'



function ThemeDemoPage() {
  return (
    <MuiComponentSamples/>
  );
}

export default ThemeDemoPage;
